import React, { useState } from 'react';

/**
 * Cycle start/end calendar. Mobile-first, fast to fill in.
 */
export default function CycleCalendar({ startDate, endDate, onChange, onSave, disabled }) {
  const [start, setStart] = useState(startDate || '');
  const [end, setEnd] = useState(endDate || '');

  const handleStartChange = (e) => {
    const v = e.target.value;
    setStart(v);
    onChange?.({ startDate: v || null, endDate: end || null });
  };

  const handleEndChange = (e) => {
    const v = e.target.value;
    setEnd(v);
    onChange?.({ startDate: start || null, endDate: v || null });
  };

  const handleSave = () => {
    if ((start || end) && onSave) onSave({ startDate: start || null, endDate: end || null });
  };

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 600 }}>
        Cycle dates
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span style={{ fontSize: 11, color: 'var(--muted)' }}>Period start</span>
          <input
            type="date"
            value={start}
            onChange={handleStartChange}
            max={today}
            disabled={disabled}
            style={{
              padding: '10px 12px',
              borderRadius: 10,
              border: '1px solid var(--border)',
              fontSize: 14,
              fontFamily: 'inherit',
            }}
          />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span style={{ fontSize: 11, color: 'var(--muted)' }}>Period end (optional)</span>
          <input
            type="date"
            value={end}
            onChange={handleEndChange}
            min={start || undefined}
            max={today}
            disabled={disabled}
            style={{
              padding: '10px 12px',
              borderRadius: 10,
              border: '1px solid var(--border)',
              fontSize: 14,
              fontFamily: 'inherit',
            }}
          />
        </label>
      </div>
      {onSave && (
        <button
          type="button"
          onClick={handleSave}
          disabled={disabled || !start}
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: 'white',
            background: start ? 'var(--pink)' : 'var(--border)',
            border: 'none',
            padding: '10px 16px',
            borderRadius: 999,
            cursor: start && !disabled ? 'pointer' : 'default',
            width: '100%',
          }}
        >
          Save cycle
        </button>
      )}
    </div>
  );
}
